export enum PLATFORM {
  STANDALONE = 'STANDALONE',
  STANDALONE_WOA = 'STANDALONE_WOA'
}

// 根据域名区分版本
export const getSite = () => {
  const { host } = window.location;
  if (host.includes('woa')) {
    return PLATFORM.STANDALONE_WOA;
  }
  return PLATFORM.STANDALONE;
};
